import React from "react";
import { Button } from "react-bootstrap";
import "./DashboardComponents.css";

// New, standalone, additive component -- not a change to any existing
// shared dashboard component. Purely presentational: `onClearFilters` is
// optional and, when provided by the caller, is expected to be an
// already-existing state setter (e.g. `() => setFilters({})`) -- this
// component introduces no new data-fetching or business logic itself.
export default function EmptyState({
  icon = "fa-inbox",
  title = "No performance data available",
  description = "Data will appear once team activity is recorded.",
  onClearFilters,
  maxHeight,
}) {
  return (
    <div className="perf-empty-state-v2" style={maxHeight ? { maxHeight } : undefined}>
      <div className="perf-empty-state-v2-icon">
        <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
      </div>
      <h6 className="perf-empty-state-v2-title">{title}</h6>
      <p className="perf-empty-state-v2-desc">{description}</p>
      {onClearFilters && (
        <Button size="sm" className="perf-empty-state-v2-btn" onClick={onClearFilters}>
          <i className="fa-solid fa-filter-circle-xmark" aria-hidden="true"></i>
          Clear Filters
        </Button>
      )}
    </div>
  );
}
